import { TableSectionProps } from './TableSection';

export const DEFAULT_VALUES: TableSectionProps = {
  title: 'Example Table',
  headers: [{ text: 'Header 1' }, { text: 'Header 2' }],
  rows: [
    {
      cells: [
        { text: '<p>Row 1, cell 1</p>' },
        { text: '<p>Row 1, cell 2</p>' },
      ],
    },
    {
      cells: [
        { text: '<p>Row 2, cell 1</p>' },
        { text: '<p>Row 2, cell 2</p>' },
      ],
    },
  ],
  sectionSpacing: '40px',
  titleElement: 'h2',
  titleSize: 'medium',
  titleAlignment: 'center',
  scrollableOnMobile: false,
};
